import React from 'react';
import { Wrapper } from './styles';
import Grid from '../components/Grid';
import { FormattedMessage } from 'react-intl';
import { TitleHeader } from 'components/commons/Template/style';
import { showModalSelector } from '../selector';
import { useSelector } from 'react-redux';
import ModalTraining from '../components/ModalDetail';

const TrainingFacilities = () => {
  const showModal = useSelector(showModalSelector);
  return (
    <Wrapper id="wrapperAccountsManager">
      <TitleHeader id="filterAccountsManager">
        <FormattedMessage id="layout.leftMenu.monitoringHistory" />
      </TitleHeader>
      <Grid />
      {showModal && <ModalTraining />}
    </Wrapper>
  );
};

export default TrainingFacilities;
